import { termPaths } from '../utils/termUtils';
import { isLocal } from './env';
import {
  ACCOUNTS_PATH,
  PARTNER_PICKER_PATH,
  CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH,
  NPC_PATH,
  CASE_MANAGEMENT_PATH,
  PERFORMANCE_INSIGHTS_PATH,
  REPORTS_SHARING_PATH,
  PERFORMANCE_DASHBOARD_PATH,
  LANDING_PAGE,
  PROFILE_PAGE,
} from './navigationalRoutes';

export const nonSignedInPageRoutes = ['faq', 'terms', 'get-started', 'privacy-notice'];
export const showUnAuthorizedAlert = [LANDING_PAGE, PROFILE_PAGE];
export const authorizedPages = isLocal()
  ? ['/account', ...termPaths]
  : [
    '/account',
    CASE_MANAGEMENT_PATH,
    NPC_PATH,
    PERFORMANCE_INSIGHTS_PATH,
    REPORTS_SHARING_PATH,
    PERFORMANCE_DASHBOARD_PATH,
    ...termPaths,
  ];
export const exceptedAuthorizedPages = [
  '/permission/denied',
  '/account',
  CASE_MANAGEMENT_PATH,
  REPORTS_SHARING_PATH,
];
export const pagesWithLpHeader = [
  ACCOUNTS_PATH,
  PARTNER_PICKER_PATH,
  CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH,
  NPC_PATH,
  CASE_MANAGEMENT_PATH,
  PERFORMANCE_INSIGHTS_PATH,
  REPORTS_SHARING_PATH,
  PERFORMANCE_DASHBOARD_PATH,
];
// Todo : reuse the LpHeader on all the term pages
export default nonSignedInPageRoutes;
